import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import currencyOptions from '../../consts/CommonCurrency.json';
import store from '../../store';

const getCurrency = () => {
    const { business } = store.getState();
    return business && business.branch ? business.branch.currencyCode : 'ILS';
};

export const attachCurrency = (amount, currency = getCurrency(), fixedValue = 2) => {
    if (String(amount).includes('/')) {
        const parts = String(amount).split('/');
        return `${attachCurrency(parts[0], currency, fixedValue)}/${attachCurrency(parts[1], currency, fixedValue)}`;
    }

    const symbol = (currencyOptions[currency] || {}).symbol_native || '';
    let amountValue = Number(amount).toFixed(fixedValue);

    if (i18next.dir() === 'rtl') {
        amountValue = Number(amountValue);
    }

    return symbol.concat(amountValue);
};

const CurrencyFormat = ({ amount, currency, ...props }) => {
    return <span {...props}>{attachCurrency(amount, currency)}</span>;
};

CurrencyFormat.propTypes = {
    amount: PropTypes.any,
    currency: PropTypes.string
};

export default CurrencyFormat;
